﻿interface FileManager {
    downloadFileFromStream(fileName: string, contentStreamReference: any): Promise<void>;
    printPdf(contentStreamReference: any): Promise<void>;
    printFromBase64?(base64: string): Promise<void>;
}

const fileManager: FileManager = {
    async downloadFileFromStream(fileName: string, contentStreamReference: any): Promise<void> {
        const arrayBuffer = await contentStreamReference.arrayBuffer();
        const blob = new Blob([arrayBuffer]);
        const url = URL.createObjectURL(blob);
        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = fileName ?? '';
        anchorElement.click();
        anchorElement.remove();
        URL.revokeObjectURL(url);
    },
    async printPdf(contentStreamReference: any): Promise<void> {
        const arrayBuffer: ArrayBuffer = await contentStreamReference.arrayBuffer();
        const blob = new Blob([arrayBuffer], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.left = "-10000px";
        iframe.style.top = "0";
        iframe.style.width = "1px";
        iframe.style.height = "1px";
        iframe.style.border = "0";
        iframe.src = url;
        document.body.appendChild(iframe);

        const waitForLoad = (el: HTMLIFrameElement) =>
            new Promise<void>((resolve) => {
                if (el.contentDocument?.readyState === "complete") resolve();
                else el.onload = () => resolve();
            });

        const cleanup = () => {
            try {
                document.body.contains(iframe) && document.body.removeChild(iframe);
            } catch { }
            try {
                URL.revokeObjectURL(url);
            } catch { }
        };

        const failSafe = setTimeout(cleanup, 60000); // 60s

        await waitForLoad(iframe);
        await new Promise((r) => setTimeout(r, 100));

        const onAfterPrint = () => {
            window.removeEventListener("afterprint", onAfterPrint);
            clearTimeout(failSafe);
            setTimeout(cleanup, 250);
        };
        window.addEventListener("afterprint", onAfterPrint);

        const mm = window.matchMedia?.("print");
        const onMM = (e: MediaQueryListEvent) => {
            if (!e.matches) {
                mm?.removeEventListener?.("change", onMM as any);
                onAfterPrint();
            }
        };
        mm?.addEventListener?.("change", onMM as any);

        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
    },
    async printFromBase64(base64: string): Promise<void> {
        const binary = atob(base64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        const blob = new Blob([bytes], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        const iframe = document.createElement("iframe");
        iframe.style.display = "none";
        iframe.src = url;

        document.body.appendChild(iframe);

        iframe.onload = () => {
            iframe.contentWindow?.focus();
            iframe.contentWindow?.print();

            setTimeout(() => {
                document.body.removeChild(iframe);
                URL.revokeObjectURL(url);
            }, 1000);
        };
    }
};

(window as any).fileManager = fileManager;